import React from 'react';
import { motion } from 'framer-motion';
export function FeaturesSection() {
  const features = [{
    emoji: '⭐',
    title: '33 relatos espirituales infantiles para acompañar noches más tranquilas y llenas de paz',
    description: 'Historias breves, dulces y profundamente inspiradoras, ideales para crear un momento especial antes de dormir.'
  }, {
    emoji: '🌟',
    title: 'Enseñanzas espirituales explicadas con ternura y simplicidad',
    description: '',
    chips: ['Amor y compasión', 'Propósito del alma', 'Vida espiritual', 'Protección divina', 'Reencarnación explicada para niños', 'Gratitud, empatía y perdón']
  }, {
    emoji: '🕊️',
    title: 'Reflexiones llenas de valores en cada cuento',
    description: 'Mensajes suaves y significativos que ayudan a fortalecer enseñanzas espirituales después de cada lectura.'
  }, {
    emoji: '👨‍👩‍👧',
    title: 'Ideal para compartir en familia, grupos infantiles o espacios educativos',
    description: 'Perfecto para padres, educadores, evangelizadores, tutores y reuniones de formación espiritual.'
  }, {
    emoji: '🎨',
    title: 'Narración sencilla, cálida y cautivadora',
    description: 'Creado para tocar el corazón de los niños… y emocionar también a los adultos.'
  }];
  return <section className="py-24 px-6 lg:px-8" data-id="element-62">
      <div className="max-w-4xl mx-auto" data-id="element-63">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-64">
          <h2 className="text-4xl md:text-5xl font-serif font-medium text-indigo mb-6" data-id="element-65">
            Lo que descubrirás dentro de esta hermosa guía
          </h2>
        </motion.div>

        <div className="space-y-6" data-id="element-66">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-3xl shadow-sm flex flex-col md:flex-row gap-6 items-start" data-id="element-67">
              <div className="text-4xl bg-cream w-16 h-16 rounded-2xl flex items-center justify-center shrink-0" data-id="element-68">
                {feature.emoji}
              </div>
              <div data-id="element-69">
                <h3 className="text-xl md:text-2xl font-serif font-medium text-indigo mb-3" data-id="element-70">
                  {feature.title}
                </h3>
                {feature.description && <p className="text-indigo/80 text-lg leading-relaxed" data-id="element-71">
                    {feature.description}
                  </p>}
                {feature.chips && <div className="flex flex-wrap gap-2 mt-4" data-id="element-72">
                    {feature.chips.map((chip, i) => <span key={i} className="bg-blush/20 text-indigo px-3 py-1.5 rounded-full text-sm font-medium" data-id="element-73">
                        → {chip}
                      </span>)}
                  </div>}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}